document.addEventListener('findstrLoaded', () => {
  const findstr = window.findstr || {};
  const { _x } = wp.i18n;

  if (typeof findstr.hooks === 'undefined') {
    return;
  }

  findstr.hooks.addFilter(
    'findstrSortLabel',
    'olhi-oap',
    function (label, field, direction) {
      const labels = {
        post_date: {
          asc: _x('Date (oldest first)', 'Findstr sort label', 'vtx'),
          desc: _x('Date (newest first)', 'Findstr sort label', 'vtx'),
        },
        post_title: {
          asc: _x('Title (A–Z)', 'Findstr sort label', 'vtx'),
          desc: _x('Title (Z–A)', 'Findstr sort label', 'vtx'),
        },
      };

      if (labels[field] && labels[field][direction]) {
        return labels[field][direction];
      }

      return label;
    }
  );
});
